import type { AmountPercentagePair } from "./types"

import { AtypicalSurchargeType, ShippingType } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

// Cost Breakdown decimal precision for all currency fields
export const COST_BREAKDOWN_DECIMAL_PRECISION = 4

// AS400 constraint: max value for cost per UoM fields
export const COST_BREAKDOWN_AS400_MAX_VALUE = 999.9999

// Common props for all cost breakdown currency FormNumericField components
export const COST_BREAKDOWN_CURRENCY_FIELD_PROPS = {
  prefix: "$" as const,
  thousandSeparator: "," as const,
  decimalScale: COST_BREAKDOWN_DECIMAL_PRECISION,
  fixedDecimalScale: true,
} as const

// Common props for all cost breakdown percentage FormNumericField components
export const COST_BREAKDOWN_PERCENTAGE_FIELD_PROPS = {
  suffix: "%" as const,
  decimalScale: COST_BREAKDOWN_DECIMAL_PRECISION,
  fixedDecimalScale: true,
} as const

export const BLANK_SHIPPING_COST_ITEM = {
  grShippingCostId: null,
  shippingType: null,
  cost: null,
} as const

export const BLANK_ATYPICAL_SURCHARGE_ITEM = {
  grAtypicalSurchargeId: null,
  description: "",
  amount: null,
} as const

export const BLANK_TARIFF_ITEM: AmountPercentagePair = {
  amount: null,
  percentage: null,
}

export const BLANK_PRODUCT_ATYPICAL_SURCHARGE_ITEM = {
  type: null,
  description: "",
  amount: null,
} as const

export const SHIPPING_TYPE_OPTIONS: Option<ShippingType>[] = [
  { value: ShippingType.Ocean, label: "Ocean" },
  { value: ShippingType.Inland, label: "Inland" },
  { value: ShippingType.Air, label: "Air" },
  { value: ShippingType.Multimodal, label: "Multimodal" },
]

export const ATYPICAL_SURCHARGE_TYPE_OPTIONS: Option<AtypicalSurchargeType>[] = [
  { value: AtypicalSurchargeType.Demurrage, label: "Demurrage" },
  { value: AtypicalSurchargeType.Detention, label: "Detention" },
  { value: AtypicalSurchargeType.ExamFee, label: "Exam Fee" },
  { value: AtypicalSurchargeType.Storage, label: "Storage" },
  { value: AtypicalSurchargeType.HazmatFee, label: "Hazmat Fee" },
  { value: AtypicalSurchargeType.Steaming, label: "Steaming" },
  { value: AtypicalSurchargeType.Cleaning, label: "Cleaning" },
  { value: AtypicalSurchargeType.Misc, label: "Misc" },
]

export const COST_BREAKDOWN_FILTER_OPTIONS: Option<boolean>[] = [
  { value: false, label: "No" },
  { value: true, label: "Yes" },
]
